import { UploadDocuments } from "components/pages/DhsPage/Forms/UploadDocuments";
import React from "react";

export const UploadDocumentsPage = () => {
  return <UploadDocuments />;
};
